import { Link, LinkType } from '@eika/link';
import './success.scss';
import { RichIcon, type RichIconTypes } from '@eika/rich-icon';
import { SuccessAnimation } from '@eika/success-animation';
import type { ReactNode } from 'react';

interface SuccessProps {
    header: string;
    ingress: string;
    href: string;
    linkText: string;
    linkType?: LinkType;
    successRichIcon?: RichIconTypes;
    children?: ReactNode;
}

export const Success = ({
    header,
    ingress,
    href,
    linkText,
    linkType = LinkType.BUTTON_STANDARD_POSITIVE,
    successRichIcon,
    children,
}: SuccessProps) => (
    <div className="success-container">
        <div className="success-container__success-message">
            <div style={{ width: '300px' }}>
                {successRichIcon ? <RichIcon type={successRichIcon} /> : <SuccessAnimation />}
            </div>
            <h1 className="success-container__success-message__header">{header}</h1>
            <p className="success-container__success-message__ingress">{ingress}</p>
            <Link linkType={linkType} href={href} className="success-container__success-message__link">
                {linkText}
            </Link>
        </div>
        {children}
    </div>
);
